import { useEffect, useState } from "react";
import firebase from '../services/Firebase.service';
import { setUserSelector } from "./store/setters";
import { useAppStore } from "./store/useAppStore";
import { getUser } from "../services/User.service";

export const useAuthStatus = () => {

   const[loggedIn, setLoggedIn] = useState(false);
   const [checkingStatus, setCheckingStatus] = useState(true);
   const setUser = useAppStore(setUserSelector);
  
   
   useEffect(() => {
       firebase.auth().onAuthStateChanged(async (user) => {
           console.log('user auth changed',user);
           if(user){
                const userData = await getUser(user.uid);
                console.log('userdata',userData);
                setLoggedIn(user);
                setUser(userData);
           }
           setCheckingStatus(false);
       })
     
    // eslint-disable-next-line
   },[])

   return { loggedIn, checkingStatus };

};